import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import { RECORD_ICONS } from 'javascripts/record_icons';
import terminology from 'javascripts/terminology';
import { type CardLayoutModelConstructorType } from '../../types';

export class RollUpInitiativeIcon extends Field {
  static subqueriesForModel(
    modelClass: CardLayoutModelConstructorType
  ): Record<string, any> {
    if (modelClass.typename === 'Initiative') {
      return { parent: ['name', 'color'] };
    }

    return {};
  }

  get title() {
    return `Roll-up ${terminology('initiative')} name`;
  }

  exampleContents(): FieldContentsData {
    return { icon: { name: RECORD_ICONS.Initiative, color: '#aaaaaa' } };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.parent) {
      return {
        icon: { name: RECORD_ICONS.Initiative, color: record.parent.color },
      };
    } else {
      return {};
    }
  }
}
